//发票管理
import { $http, buildHeaders } from "./index";

//获取开票列表
export const invoice_list = (params) => {
  return $http.get("/admin/Invoice/index", { params });
};

//获取开票详情
export const invoice_detail = (id) => {
  return $http.get("/admin/Invoice/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取开票日志
export const invoice_log = (id) => {
  return $http.get("/admin/Invoice/log", {
    params: {
      limit: 0,
      invoice_id: id,
    },
  });
};

//删除
export const invoice_del = (data) => {
  return $http.post("/admin/Invoice/del", data, {
    headers: buildHeaders(3),
  });
};

//从税局更新数据
export const invoice_pull = (data) => {
  return $http.post("/admin/Invoice/pull", data, {
    headers: buildHeaders(3),
  });
};

//开票通过
export const invoice_pass = (data) => {
  return $http.post("/admin/Invoice/pass", data, {
    headers: buildHeaders(3),
  });
};

//开票不通过
export const invoice_reject = (data) => {
  return $http.post("/admin/Invoice/reject", data, {
    headers: buildHeaders(3),
  });
};
